<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  text-decoration: none;
  list-style: none;
  /* user-select: none; */
}
.left {
  float: left;
}
.clear {
  clear: both;
}
</style>



// WEBPACK FOOTER //
// src/App.vue